import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import useAccessToken from "../../auth/useAccessToken";
import { validateClientEmail } from "../../api/organizations";
import { isApiError } from "../../api/common/apiError";

export type ClientInviteUserFormValues = {
    emails: string[],
};

export const useClientInviteUsersForm = () => {
    const schema = clientValidationSchema();

    return useForm<ClientInviteUserFormValues>({
        resolver: yupResolver(schema),
        mode: "onChange",
        defaultValues: {
            emails: [],
        },
    });
};

const clientValidationSchema = () => {
    const token = useAccessToken();

    return yup
        .object({
            emails: yup.array().of(yup.string()
                .email(error => `"${error.value}" is an invalid email`)
                .test("validate-email", "\"${value}\" is already a member of another client. You can manage users from the Clients table.", async (value, context) => {
                    if (context.parent.length === 0) return true;
                    if (value === undefined) return true;
                    if (token === null) throw new Error("Expected token in context when validating email.");
                    try {
                        if ( context.parent.length == 0) {
                            return context.createError({ message: "You must add at least one email."});
                        }
                        if ((context.parent.filter((item: string) => item == value).length) > 1) {
                            return context.createError({ message: "Email address \"${value}\" has been entered more than once." });
                        } else {
                            await validateClientEmail(value, token);
    
                            return true;
                        }
                    }
                    catch (error) {
                        if (isApiError(error)) {
                            return context.createError({ message: error.userMessages[0] });
                        }
                        else
                        {
                            return context.createError({ message: "Email validation failed for unknown reason." });
                        }
                    }
                })
            ),
        })
        .required();
};